import React from "react"
import styled from "styled-components"
import {Box, Card, FormControl} from "@material-ui/core"

function Header({title, children}) {
	return (
		<Box mb={3}>
			<Card>
				<HeaderBox p={4}>
					<Title>{title}</Title>
					{children}
				</HeaderBox>
			</Card>
		</Box>
	)
}

const Title = styled.div`
	display: inline-block;
	font-size: 1.5rem;
	margin-right: 2rem;
`

const HeaderBox = styled(Box)`
	display: flex;
	align-items: center;
`

const HeaderFormControl = styled(FormControl)`
	margin-right: 1rem;
	vertical-align: baseline;
`

export {Header, HeaderFormControl}
